import { render, staticRenderFns } from "./Waste_lifting_lists.vue?vue&type=template&id=60cfc5c2&"
import script from "./Waste_lifting_lists.vue?vue&type=script&lang=js&"
export * from "./Waste_lifting_lists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports